import { render, staticRenderFns } from "./popup-alert.vue?vue&type=template&id=35dcba54&scoped=true"
import script from "./popup-alert.vue?vue&type=script&lang=ts"
export * from "./popup-alert.vue?vue&type=script&lang=ts"
import style0 from "./popup-alert.vue?vue&type=style&index=0&id=35dcba54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcba54",
  null
  
)

export default component.exports